export const messageListAriaLabel = "myc";
export default {messageListAriaLabel};